import { Builder } from "@builder.io/react";
import { BuilderFoundationIcon } from "@faire/builder-core/registerBuilderComponents/__internal__/BuilderFoundationIcon";

import { BuilderIconConfig } from "./BuilderIconConfig";

export const registerBuilderFoundationIcon = () => {
  Builder.registerComponent(BuilderFoundationIcon, {
    name: "FoundationIcon",
    hideFromInsertMenu: false,
    canHaveChildren: false,
    inputs: BuilderIconConfig,
  });
};
